import { z } from 'zod';

/////////////////////////////////////////
// CELETTER SCHEMA
/////////////////////////////////////////

export const celetterSchema = z.object({
  celetterId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  letterTemplate: z.string(),
  letterFooter1: z.string(),
  letterFooter2: z.string(),
  letterFooter3: z.string(),
  letterFooter4: z.string(),
  letterFooter5: z.string(),
  letterFooter6: z.string(),
  letterFooter7: z.string(),
  letterFooter8: z.string(),
  letterFooter9: z.string(),
  letterFooter10: z.string(),
  letterFooter11: z.string(),
  letterFooter12: z.string(),
  letterFooter13: z.string(),
  letterFooter14: z.string(),
  letterFooter15: z.string(),
  letterFooter16: z.string(),
  letterFooter17: z.string(),
  letterFooter18: z.string(),
  letterFooter19: z.string(),
  letterFooter20: z.string(),
  printAddresses: z.string(),
  datePrinted: z.coerce.date(),
  letterText: z.string(),
  letterEdited: z.number().int(),
  letterParms: z.string(),
  letterRemoteLocation: z.string().nullable(),
  letterFilename: z.string().nullable(),
})

export type celetter = z.infer<typeof celetterSchema>

export default celetterSchema;
